<template>
  <div>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">
        <b-row>
          <b-col>
            <b-row class="justify-content-center my-4">
              <b-col class="mb-4 mb-sm-0" cols="12" sm="6" md="5" lg="4">
                <label>Indiquer la date</label>
                <ValidationProvider
                  ref="vee-meeting-meeting_date"
                  v-slot="{ errors, classes }"
                  :name="'réunion date'"
                  rules="required"
                  :events="['change']"
                  mode="passive"
                >
                  <v-date-picker
                    v-model="meeting.meeting_date"
                    locale="fr"
                    mode="dateTime"
                    is-required
                    is24hr
                    :timezone="timezone"
                    :masks="masks"
                    @change="
                      updateMeeting(
                        'meeting_date',
                        $event ? $moment($event).format('YYYY-MM-DDTHH:mm:ssZ') : null
                      )
                    "
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        class="bg-white border px-2 py-1 rounded"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                    </template>
                  </v-date-picker>
                  <span :class="classes" class="text-center">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="justify-content-center my-2">
          <b-col cols="10">
            <h5>Modalités de participation</h5>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="10">
            <b-form-checkbox
              v-model="meeting.allowed_modalities.physical"
              name="check-button"
              switch
            >
              Physique
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row
          v-if="meeting.allowed_modalities.physical == true"
          class="justify-content-center my-2"
        >
          <b-col class="mb-4 mb-sm-0" cols="12" sm="6" md="5" lg="4">
            <label>Lieu, addresse</label>
            <ValidationProvider
              ref="vee-physique-first-address"
              v-slot="{ errors, classes }"
              :name="'lieu, addresse'"
              rules="required"
            >
              <tiptap
                v-model="meeting.address"
                @updateOnFocusOut="updateMeetingTextarea($event, 'address')"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col cols="12" sm="6" md="5" lg="4">
            <label>Préciser les modalités d’accès</label>
            <tiptap
              v-model="meeting.access"
              @updateOnFocusOut="updateMeetingTextarea($event, 'access')"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="10" class="my-2">
            <b-form-checkbox
              v-model="meeting.allowed_modalities.correspondence"
              name="check-button"
              switch
              @input="correspondenceChanged"
            >
              Correspondance
            </b-form-checkbox>
            <div class="d-flex flex-column">
              <div class="ml-5 my-1">
                <font-awesome-icon icon="info-circle" />
                <span>Le formulaire sera automatiquement ajouté dans la convocation.</span>
              </div>
              <div class="ml-5 my-1">
                <font-awesome-icon icon="asterisk" />
                <span
                  >Les participants pourront également vote par correspondance à partir de leur
                  espace personnel</span
                >
              </div>

              <div v-if="meeting.allowed_modalities.correspondence" class="ml-5">
                <label>La date limite de réception :</label>
                <v-date-picker
                  :value="meeting.last_reception_date"
                  locale="fr"
                  mode="date"
                  is-required
                  :timezone="timezone"
                  :masks="masks"
                  :max-date="meeting.meeting_date"
                  @input="
                    updateMeeting(
                      'last_reception_date',
                      $event ? $moment($event).format('YYYY-MM-DDTHH:mm:ssZ') : null
                    )
                  "
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="bg-white border px-2 py-1 rounded"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
          </b-col>
          <b-col cols="10" class="my-2">
            <b-form-checkbox
              v-model="meeting.allowed_modalities.video"
              name="check-button"
              switch
            >
              Videoconférence
              <br />
              <font-awesome-icon icon="info-circle" />
              <span>Les modalités de connexion seront transmis dans la convocation</span>
            </b-form-checkbox>
            <b-form-checkbox
              v-if="meeting.allowed_modalities.video"
              v-model="isExternalVideoSolution"
              name="check-button"
              switch
              class="ml-5 mt-2"
              @change="onChangeExternalVideoSolution"
            >
              Utiliser une solution vidéo externe
              <br />
              <div v-if="isExternalVideoSolution">
                <ValidationProvider
                  ref="vee-meeting-external-video-solution"
                  v-slot="{ errors, classes }"
                  :name="'solution vidéo externe'"
                  rules="required"
                >
                  <b-input
                    :value="meeting.external_video_solution"
                    @input="updateMeeting('external_video_solution', $event)"
                  ></b-input>
                  <span :class="classes">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="10"
            class="my-2"
          >
            <hr />
            <b-form-checkbox v-model="meeting.show_connection_details" name="check-button" switch>
              Afficher les informations de connexion à l'espace personnel sur le PDF d'invitation
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
import VDatePicker from "v-calendar/lib/components/date-picker.umd";
import Tiptap from "@/components/snippets/Tiptap.vue";

export default {
  components: {
    vCalendar: VCalendar,
    vDatePicker: VDatePicker,
    Tiptap,
  },
  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isExternalVideoSolution: false,
      masks: {
        input: ["DD MMMM YYYY", "YYYY-MM-DD", "YYYY/MM/DD"],
        inputDateTime: ["DD MMMM YYYY HH:mm", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"],
        inputDateTime24hr: ["DD MMMM YYYY HH:mm", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"],
      },
    };
  },
  computed: {
    timezone() {
      return localStorage.getItem("timezone");
    },
    meeting_date() {
      return this.meeting.meeting_date;
    },
  },
  watch: {
    meeting_date(newVal, oldVal) {
      if (
        this.meeting.allowed_modalities.correspondence &&
        this.meeting.last_reception_date == null
      ) {
        this.meeting.last_reception_date = this.substract4Days();
      }
      if (
        this.meeting.allowed_modalities.correspondence &&
        this.$moment(this.meeting.meeting_date).isBefore(this.meeting.last_reception_date)
      ) {
        this.meeting.last_reception_date = this.substract4Days();
      }
    },
  },
  created() {
    this.checkExternalVideoSolution();
    if (this.timezone) {
      this.$moment.tz.setDefault(this.timezone);
    }
  },
  methods: {
    updateMeeting(key, value) {
      this.$emit("updateMeeting", key, value);
    },
    updateMeetingTextarea(text, key) {
      this.meeting[key] = text;
      this.$emit("updateMeeting", key, text);
    },
    correspondenceChanged(input) {
      if (input) {
        this.meeting.last_reception_date = this.substract4Days();
      } else {
        this.meeting.last_reception_date = null;
      }
    },
    substract4Days() {
      if (this.meeting.meeting_date) {
        var date = this.$moment(this.meeting.meeting_date).format("YYYY-MM-DD");
        var x = this.$moment(date).subtract(4, "days");
        return this.$moment(x).format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        return null;
      }
    },
    datecheck(date) {
      if (this.meeting.meeting_date) {
        if (new Date(date) < new Date(this.meeting.meeting_date)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkExternalVideoSolution() {
      if (this.meeting.external_video_solution) {
        this.isExternalVideoSolution = true;
      }
    },
    onChangeExternalVideoSolution(event) {
      if (event) {
        this.updateMeeting("isExternalVideoSolutionUsed", true);
      } else {
        this.updateMeeting("isExternalVideoSolutionUsed", false);
        this.updateMeeting("external_video_solution", null);
      }
    },
  },
};
</script>
